module.exports = __webpack_public_path__ + "static/img/streifen.988308f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/streifen.png
// module id = Ghy+
// module chunks = 1